import Phaser from 'phaser';
import { SCENES } from '../config/constants';
import { gameStore } from '../simulation/GameStore';
import { HUD } from '../ui/HUD';

/**
 * UIScene (spec section 45): a lightweight Phaser scene that owns the HTML HUD
 * overlay lifecycle. It runs in parallel with CityScene. Keeping the DOM HUD
 * behind a scene means it is created/destroyed cleanly with the game view.
 */
export class UIScene extends Phaser.Scene {
  private hud?: HUD;

  constructor() {
    super(SCENES.UI);
  }

  create(): void {
    const overlay = document.getElementById('ui-overlay');
    if (!overlay) {
      // Overlay is defined in index.html; without it the HUD cannot mount.
      console.warn('[UIScene] #ui-overlay not found; HUD will not render.');
      return;
    }

    this.hud = new HUD(overlay, gameStore, () => this.returnToMenu());

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.teardown());
    this.events.once(Phaser.Scenes.Events.DESTROY, () => this.teardown());
  }

  private returnToMenu(): void {
    gameStore.pause();
    gameStore.saveGame();
    // Stop every gameplay scene (only the active one actually does anything).
    this.scene.stop(SCENES.CITY);
    this.scene.stop(SCENES.PARKING_LOT);
    this.scene.stop(SCENES.UI); // triggers SHUTDOWN -> teardown
    this.scene.start(SCENES.MAIN_MENU);
  }

  private teardown(): void {
    this.hud?.destroy();
    this.hud = undefined;
  }

  /**
   * The UI scene persists across City/ParkingLot, so it owns the simulation
   * loop. `delta` is real ms since the last frame; the store converts it into
   * fixed ticks (decoupled from FPS, spec section 4).
   */
  update(_time: number, delta: number): void {
    gameStore.tick(delta);
  }
}
